export const ownerSelector = (state) => state.roleReducer.owner;
export const isOwnerSelector = (state) => state.roleReducer.isOwner;
